import { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";

import Image4 from "../../assets/images/icon-1-new.png";
import Image5 from "../../assets/images/icon-3.jpg";
import Image6 from "../../assets/images/icon-2.jpg";
import Image7 from "../../assets/images/icon-4-new.png";
import CrisilCertificate from "../../assets/images/crisil-rating.webp"; // Make sure this path is correct
import "./Financially.css";

const features = [
  {
    image: Image4,
    title: "100% Equity with promoters",
    desc: "Gautam Solar is privately held, with 100% equity with its promoters to ensure a long term outlook for the company as it allows the company to adapt to the changing market conditions with quicker and more decisive action and allow a long-term planning and execution of strategic initiatives.",
    alt: true,
  },
  {
    image: Image5,
    title: "Profitable in Solar since last 29 years",
    desc: "Gautam Solar has been consistently profitable in the solar industry since the last 29 years, unlike a number of solar energy startups which have come into existence in just the past few years and are yet to reach profitability.",
    alt: false,
  },
  {
    image: Image6,
    title: "Bankable Company for Solar Modules",
    desc: "Gautam Solar is a bankable company for businesses looking to procure solar modules, as evidenced by the company's strong balance sheet. Additionally, the company has a provision for a warranty fund and cash to withstand warranty claims.",
    alt: false,
  },
  {
    image: Image7,
    title: "In Solar since 1998",
    desc: "Gautam Solar provides a 10-year product warranty and a 25-year performance warranty, backed by over 29 years of industry experience. It matches the typical lifetime of a Solar Plant in contrast to some less experienced companies, sourcing modules from China, which have faced bankruptcy or warranty issues.",
    alt: true,
  },
];

function Financially() {
  const [showCertificate, setShowCertificate] = useState(false);

  const openCertificate = () => setShowCertificate(true);
  const closeCertificate = useCallback(() => setShowCertificate(false), []);

  // Close on Escape + lock body scroll while the modal is open
  useEffect(() => {
    if (!showCertificate) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") closeCertificate();
    };

    document.addEventListener("keydown", handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [showCertificate, closeCertificate]);

  return (
    <section className="financially-section">
      <Container>
        <Row className="justify-content-center mb-4">
          <Col xs={12} md={10} className="text-center">
            <h2 className="financial-section-title">
              <span className="financial-section-title__accent">Financially</span> Strong
            </h2>
          </Col>
        </Row>

        <Row className="justify-content-center">
          {features.map((feature, idx) => (
            <Col xs={12} key={idx}>
              <div className={`financial-feature-card${feature.alt ? " alt" : ""}`}>
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="financial-feature-img"
                />
                <div className="financial-feature-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.desc}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* ---- Crisil Rating Certificate Thumbnail ---- */}
        <Row className="justify-content-center mt-5">
          <Col xs={12} className="d-flex justify-content-center">
            <div
              onClick={openCertificate}
              style={{
                width: "100%",
                maxWidth: "750px", // Significantly increased size
                cursor: "zoom-in",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)", // Softer, larger shadow
                border: "1px solid #E4E1DA", // Clean subtle border
                backgroundColor: "#fff",
                transition: "transform 0.3s ease, boxShadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.01)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(162,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
              }}
            >
              <img
                src={CrisilCertificate}
                alt="Crisil Rating Certificate"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>

      {/* ---- FULL SCREEN MODAL (INLINE CSS) ---- */}
      {showCertificate && (
        <div
          onClick={closeCertificate}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999, // Ensures it sits on top of everything
            padding: "20px",
          }}
        >
          <button
            onClick={closeCertificate}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              background: "transparent",
              border: "none",
              color: "#ffffff",
              fontSize: "45px",
              fontWeight: "bold",
              cursor: "pointer",
              lineHeight: "1",
              zIndex: 100000,
            }}
            aria-label="Close certificate"
          >
            &times;
          </button>

          <img
            src={CrisilCertificate}
            alt="Crisil Rating Certificate Full View"
            onClick={(e) => e.stopPropagation()} // Prevents closing when clicking the image itself
            style={{
              maxWidth: "95%",
              maxHeight: "95%",
              objectFit: "contain",
              borderRadius: "5px",
              boxShadow: "0 10px 40px rgba(0,0,0,0.8)",
              backgroundColor: "#fff", // Ensures the certificate background is white
            }}
          />
        </div>
      )}
    </section>
  );
}

export default Financially;